<template>
  <div class="errors-server-error-view">
    <h1>
      {{$t('titles.serverError')}}
    </h1>
    <alert-box type="danger" icon="bolt">
      {{ message || $t('hints.serverError')}}
    </alert-box>
    <link-button v-if="referrer" :to="{ path: referrer }" icon="refresh">
      {{$t('actions.retry')}}
    </link-button>
  </div>
</template>

<script>
import AlertBox from '@/components/AlertBox';
import View from '@/mixins/View';

export default {
  name: 'errors-server-error-view',
  mixins: [View],
  components: {
    AlertBox,
  },
  computed: {
    referrer() {
      return this.$route.query.from;
    },
    error() {
      return this.$route.query.message
        ? JSON.parse(this.$route.query.message)
        : undefined;
    },
    message() {
      return this.error ? this.error.message : undefined;
    },
  },
  i18n: {
    messages: {
      de: {
        actions: {
          retry: 'Erneut versuchen',
        },
        titles: {
          serverError: 'Kritischer Fehler',
        },
        hints: {
          serverError: `Ein kritischer Fehler ist aufgetreten. Bitte versuch
                        es später erneut oder wende dich an einen
                        Administrator.`,
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// ServerErrorView.vue?1155482e